/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientFormTemplateExternalIdSource = "docusign" | "hellosign" | "luma" | "surveymonkey" | "%future added value";
export type EnumPatientFormTemplateLumaBotFlow = "authenticatePatient" | "culDeSac" | "default" | "feedback" | "knockKnock" | "partialKnockKnock" | "partialSessionTimeout" | "partialSpeakWithStaff" | "sessionTimeout" | "speakWithStaff" | "welcome" | "%future added value";
export type EnumPatientFormTemplateType = "ccda" | "feedback" | "intake" | "preQualification" | "%future added value";
export type FilterFindManyPatientFormTemplateInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    source?: string | null | undefined;
    externalId?: PatientFormTemplateExternalIdInput | null | undefined;
    title?: string | null | undefined;
    description?: string | null | undefined;
    insurance?: PatientFormTemplateInsuranceInput | null | undefined;
    reminder?: PatientFormTemplateReminderInput | null | undefined;
    type?: EnumPatientFormTemplateType | null | undefined;
    active?: boolean | null | undefined;
    url?: string | null | undefined;
    tag?: string | null | undefined;
    template?: unknown | null | undefined;
    integratorMapping?: string | null | undefined;
    calculation?: string | null | undefined;
    finalDispositionCalculation?: string | null | undefined;
    schedulerRequestInterceptor?: string | null | undefined;
    schedulerResponseInterceptor?: string | null | undefined;
    htmlPdfTemplateHeader?: string | null | undefined;
    htmlPdfTemplateBody?: string | null | undefined;
    htmlPdfTemplateFooter?: string | null | undefined;
    lumabot?: boolean | null | undefined;
    sendToDirectMessageEmail?: boolean | null | undefined;
    lumaBotFlow?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    OR?: Array<FilterFindManyPatientFormTemplateInput> | null | undefined;
    AND?: Array<FilterFindManyPatientFormTemplateInput> | null | undefined;
};
export type PatientFormTemplateExternalIdInput = {
    source?: EnumPatientFormTemplateExternalIdSource | null | undefined;
    value?: string | null | undefined;
    _id?: string | null | undefined;
};
export type PatientFormTemplateInsuranceInput = {
    enabled?: boolean | null | undefined;
    _id?: string | null | undefined;
};
export type PatientFormTemplateReminderInput = {
    enabled?: boolean | null | undefined;
    _id?: string | null | undefined;
};
export type OperatorsFilterFindManyPatientFormTemplateInput = {
    user?: UserOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    _id?: _idOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    source?: SourceOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    externalId?: ExternalIdOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    title?: TitleOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    description?: DescriptionOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    insurance?: InsuranceOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    reminder?: ReminderOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    type?: TypeOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    active?: ActiveOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    url?: UrlOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    tag?: TagOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    template?: TemplateOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    integratorMapping?: IntegratorMappingOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    calculation?: CalculationOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    finalDispositionCalculation?: FinalDispositionCalculationOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    schedulerRequestInterceptor?: SchedulerRequestInterceptorOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    schedulerResponseInterceptor?: SchedulerResponseInterceptorOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    htmlPdfTemplateHeader?: HtmlPdfTemplateHeaderOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    htmlPdfTemplateBody?: HtmlPdfTemplateBodyOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    htmlPdfTemplateFooter?: HtmlPdfTemplateFooterOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    lumabot?: LumabotOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    sendToDirectMessageEmail?: SendToDirectMessageEmailOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
    lumaBotFlow?: LumaBotFlowOperatorsFilterFindManyPatientFormTemplateInput | null | undefined;
};
export type UserOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SourceOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ExternalIdOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: PatientFormTemplateExternalIdInput | null | undefined;
    gte?: PatientFormTemplateExternalIdInput | null | undefined;
    lt?: PatientFormTemplateExternalIdInput | null | undefined;
    lte?: PatientFormTemplateExternalIdInput | null | undefined;
    ne?: PatientFormTemplateExternalIdInput | null | undefined;
    in?: Array<PatientFormTemplateExternalIdInput | null> | null | undefined;
    nin?: Array<PatientFormTemplateExternalIdInput | null> | null | undefined;
    regex?: PatientFormTemplateExternalIdInput | null | undefined;
};
export type TitleOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DescriptionOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type InsuranceOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: PatientFormTemplateInsuranceInput | null | undefined;
    gte?: PatientFormTemplateInsuranceInput | null | undefined;
    lt?: PatientFormTemplateInsuranceInput | null | undefined;
    lte?: PatientFormTemplateInsuranceInput | null | undefined;
    ne?: PatientFormTemplateInsuranceInput | null | undefined;
    in?: Array<PatientFormTemplateInsuranceInput | null> | null | undefined;
    nin?: Array<PatientFormTemplateInsuranceInput | null> | null | undefined;
    regex?: PatientFormTemplateInsuranceInput | null | undefined;
};
export type ReminderOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: PatientFormTemplateReminderInput | null | undefined;
    gte?: PatientFormTemplateReminderInput | null | undefined;
    lt?: PatientFormTemplateReminderInput | null | undefined;
    lte?: PatientFormTemplateReminderInput | null | undefined;
    ne?: PatientFormTemplateReminderInput | null | undefined;
    in?: Array<PatientFormTemplateReminderInput | null> | null | undefined;
    nin?: Array<PatientFormTemplateReminderInput | null> | null | undefined;
    regex?: PatientFormTemplateReminderInput | null | undefined;
};
export type TypeOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: EnumPatientFormTemplateType | null | undefined;
    gte?: EnumPatientFormTemplateType | null | undefined;
    lt?: EnumPatientFormTemplateType | null | undefined;
    lte?: EnumPatientFormTemplateType | null | undefined;
    ne?: EnumPatientFormTemplateType | null | undefined;
    in?: Array<EnumPatientFormTemplateType | null> | null | undefined;
    nin?: Array<EnumPatientFormTemplateType | null> | null | undefined;
    regex?: EnumPatientFormTemplateType | null | undefined;
};
export type ActiveOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type UrlOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TagOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TemplateOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type IntegratorMappingOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type CalculationOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FinalDispositionCalculationOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SchedulerRequestInterceptorOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type SchedulerResponseInterceptorOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type HtmlPdfTemplateHeaderOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type HtmlPdfTemplateBodyOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type HtmlPdfTemplateFooterOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type LumabotOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type SendToDirectMessageEmailOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type LumaBotFlowOperatorsFilterFindManyPatientFormTemplateInput = {
    gt?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    gte?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    lt?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    lte?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    ne?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
    in?: Array<EnumPatientFormTemplateLumaBotFlow | null> | null | undefined;
    nin?: Array<EnumPatientFormTemplateLumaBotFlow | null> | null | undefined;
    regex?: EnumPatientFormTemplateLumaBotFlow | null | undefined;
};
export type FilterPatientFormDataQueryVariables = {
    filter?: FilterFindManyPatientFormTemplateInput | null | undefined;
};
export type FilterPatientFormDataQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"FilterPatientFormList_Query">;
};
export type FilterPatientFormDataQuery = {
    readonly response: FilterPatientFormDataQueryResponse;
    readonly variables: FilterPatientFormDataQueryVariables;
};



/*
query FilterPatientFormDataQuery(
  $filter: FilterFindManyPatientFormTemplateInput
) {
  ...FilterPatientFormList_Query
}

fragment FilterPatientFormList_Query on Query {
  patientFormTemplateConnection(first: 25, filter: $filter, sort: TITLE_ASC) {
    edges {
      node {
        _id
        title
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "TITLE_ASC"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FilterPatientFormDataQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "FilterPatientFormList_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FilterPatientFormDataQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PatientFormTemplateConnection",
        "kind": "LinkedField",
        "name": "patientFormTemplateConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFormTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientFormTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "_id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filter",
          "sort"
        ],
        "handle": "connection",
        "key": "FilterPatientFormList_patientFormTemplateConnection",
        "kind": "LinkedHandle",
        "name": "patientFormTemplateConnection"
      }
    ]
  },
  "params": {
    "cacheID": "f47720afe3ec355181863634736439aa",
    "id": null,
    "metadata": {},
    "name": "FilterPatientFormDataQuery",
    "operationKind": "query",
    "text": "query FilterPatientFormDataQuery(\n  $filter: FilterFindManyPatientFormTemplateInput\n) {\n  ...FilterPatientFormList_Query\n}\n\nfragment FilterPatientFormList_Query on Query {\n  patientFormTemplateConnection(first: 25, filter: $filter, sort: TITLE_ASC) {\n    edges {\n      node {\n        _id\n        title\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd731e463b1f4140c0390cbca1d9a5261';
export default node;
